/** Catálogo de paletas — GoBooking White Label (2025/2026). */

export type ThemePaletteColors = {
  primaria: string
  secundaria: string
  destaque: string
}

export type ThemePaletteStyle = {
  id: string
  nome: string
  vibe: string
} & ThemePaletteColors

export type ThemePaletteNiche = {
  id: string
  nome: string
  estilos: ThemePaletteStyle[]
}

export const WHITE_LABEL_THEME_CATALOG: ThemePaletteNiche[] = [
  {
    id: 'barbershop',
    nome: 'Barbershop (Barbeiro)',
    estilos: [
      { id: 'industrial', nome: 'Industrial', primaria: '#1A1A1B', secundaria: '#4A4A4A', destaque: '#C5A059', vibe: 'Sofisticação urbana — aço e couro.' },
      { id: 'retro', nome: 'Retrô', primaria: '#2C1B18', secundaria: '#D9D9D9', destaque: '#8B0000', vibe: 'Barbearia clássica com madeira e vinho.' },
      { id: 'minimalista', nome: 'Minimalista', primaria: '#000000', secundaria: '#FFFFFF', destaque: '#32CD32', vibe: 'Contraste absoluto para público jovem e tecnológico.' },
    ],
  },
  {
    id: 'nail-design',
    nome: 'Nail Design / Estética',
    estilos: [
      { id: 'luxo-silencioso', nome: 'Luxo silencioso', primaria: '#F7D9D9', secundaria: '#E8D3C3', destaque: '#F3E5AB', vibe: 'Elegância discreta, limpeza e cuidado.' },
      { id: 'holistico', nome: 'Holístico', primaria: '#E0F2F1', secundaria: '#B2DFDB', destaque: '#004D40', vibe: 'Natureza e bem-estar terapêutico.' },
      { id: 'glamour', nome: 'Glamour', primaria: '#2D1B4E', secundaria: '#FFD700', destaque: '#FFFFFF', vibe: 'Exclusividade, brilho e serviços premium.' },
    ],
  },
  {
    id: 'contabilidade',
    nome: 'Contabilidade / Admin',
    estilos: [
      { id: 'institucional', nome: 'Institucional', primaria: '#002366', secundaria: '#4682B4', destaque: '#D1D5DB', vibe: 'Segurança, estabilidade e tradição.' },
      { id: 'modern-corp', nome: 'Modern Corp.', primaria: '#1F2937', secundaria: '#10B981', destaque: '#F9FAFB', vibe: 'Eficiência, crescimento financeiro e agilidade.' },
      { id: 'trust-tech', nome: 'Trust Tech', primaria: '#0F172A', secundaria: '#38BDF8', destaque: '#FFFFFF', vibe: 'Startup financeira moderna e transparente.' },
    ],
  },
  {
    id: 'arquitetura',
    nome: 'Arquitetura / Design',
    estilos: [
      { id: 'brutalista', nome: 'Brutalista', primaria: '#A9A9A9', secundaria: '#3D2B1F', destaque: '#36454F', vibe: 'Concreto e materiais crus.' },
      { id: 'sustentavel', nome: 'Sustentável', primaria: '#F5F5DC', secundaria: '#556B2F', destaque: '#8B4513', vibe: 'Eco-design, biofilia e conforto ambiental.' },
      { id: 'high-tech', nome: 'High-Tech', primaria: '#000000', secundaria: '#E5E7EB', destaque: '#FF3E00', vibe: 'Vanguarda, precisão e inovação estrutural.' },
    ],
  },
  {
    id: 'restaurante',
    nome: 'Restaurante / Gastronomia',
    estilos: [
      { id: 'artesanal', nome: 'Artesanal', primaria: '#B2441D', secundaria: '#E1AD01', destaque: '#1B3022', vibe: 'Calor, tempero e comida feita à mão.' },
      { id: 'fast-fresh', nome: 'Fast & Fresh', primaria: '#EF4444', secundaria: '#F59E0B', destaque: '#FFFFFF', vibe: 'Apetite e rapidez no atendimento.' },
      { id: 'bistro-night', nome: 'Bistro Night', primaria: '#1A1A1A', secundaria: '#800020', destaque: '#C0C0C0', vibe: 'Intimista, sofisticado e noturno.' },
    ],
  },
  {
    id: 'cuidadores',
    nome: 'Cuidadores de Idosos / Saúde',
    estilos: [
      { id: 'acolhimento', nome: 'Acolhimento', primaria: '#87CEEB', secundaria: '#9C9F84', destaque: '#FAF9F6', vibe: 'Paz, serenidade e confiança para famílias.' },
      { id: 'vitalidade', nome: 'Vitalidade', primaria: '#0D9488', secundaria: '#F0FDFA', destaque: '#FB923C', vibe: 'Energia positiva, saúde ativa e reabilitação.' },
      { id: 'clinica-soft', nome: 'Clínica Soft', primaria: '#FFFFFF', secundaria: '#E2E8F0', destaque: '#6366F1', vibe: 'Profissionalismo médico com interface limpa.' },
    ],
  },
  {
    id: 'advogados',
    nome: 'Advogados / Jurídico',
    estilos: [
      { id: 'tradicional', nome: 'Tradicional', primaria: '#4E0707', secundaria: '#001F3F', destaque: '#C0C0C0', vibe: 'Solenidade, peso histórico e autoridade.' },
      { id: 'moderna', nome: 'Moderna', primaria: '#111827', secundaria: '#9CA3AF', destaque: '#D4AF37', vibe: 'Direito dinâmico, resultados e prestígio.' },
      { id: 'etica', nome: 'Ética', primaria: '#2F4F4F', secundaria: '#FFFFFF', destaque: '#B8860B', vibe: 'Equilíbrio, justiça e transparência.' },
    ],
  },
  {
    id: 'bandas',
    nome: 'Bandas / Entretenimento',
    estilos: [
      { id: 'rock-metal', nome: 'Rock / Metal', primaria: '#000000', secundaria: '#FF0000', destaque: '#666666', vibe: 'Atitude, força e alto impacto visual.' },
      { id: 'indie-pop', nome: 'Indie / Pop', primaria: '#FF00FF', secundaria: '#00FFFF', destaque: '#FFFF00', vibe: 'Vibrante, criativo e público jovem.' },
      { id: 'folk-acoustic', nome: 'Folk / Acoustic', primaria: '#4B3621', secundaria: '#D2B48C', destaque: '#F5F5DC', vibe: 'Orgânico, intimista e instrumentos reais.' },
    ],
  },
  {
    id: 'igrejas',
    nome: 'Igrejas / Comunidade',
    estilos: [
      { id: 'celestial', nome: 'Celestial', primaria: '#4A90E2', secundaria: '#D4AF37', destaque: '#F9F9F9', vibe: 'Espiritualidade, luz e conexão divina.' },
      { id: 'contemporanea', nome: 'Contemporânea', primaria: '#312E81', secundaria: '#818CF8', destaque: '#FFFFFF', vibe: 'Comunidade ativa, jovem e eventos.' },
      { id: 'natureza', nome: 'Natureza', primaria: '#365314', secundaria: '#FEFCE8', destaque: '#B45309', vibe: 'Paz, renovação e acolhimento comunitário.' },
    ],
  },
  {
    id: 'mercado',
    nome: 'Mercado / Varejo',
    estilos: [
      { id: 'fresh-market', nome: 'Fresh Market', primaria: '#32CD32', secundaria: '#FF8C00', destaque: '#FFFFFF', vibe: 'Produtos frescos, saudáveis e orgânicos.' },
      { id: 'premium', nome: 'Premium', primaria: '#000000', secundaria: '#FFD700', destaque: '#E5E7EB', vibe: 'Exclusividade, curadoria e importados.' },
      { id: 'discount', nome: 'Discount', primaria: '#E11D48', secundaria: '#FACC15', destaque: '#1E40AF', vibe: 'Preço, promoções e volume de vendas.' },
    ],
  },
  {
    id: 'pet-shop',
    nome: 'Pet Shop / Veterinária',
    estilos: [
      { id: 'amigavel', nome: 'Amigável', primaria: '#60A5FA', secundaria: '#F472B6', destaque: '#FEF3C7', vibe: 'Carinho, diversão e cuidado com animais.' },
      { id: 'natural', nome: 'Natural', primaria: '#065F46', secundaria: '#D1FAE5', destaque: '#F59E0B', vibe: 'Alimentação natural e saúde holística pet.' },
      { id: 'tech-pet', nome: 'Tech Pet', primaria: '#4F46E5', secundaria: '#FFFFFF', destaque: '#94A3B8', vibe: 'Serviços modernos e telemedicina pet.' },
    ],
  },
  {
    id: 'imobiliaria',
    nome: 'Imobiliária',
    estilos: [
      { id: 'luxo', nome: 'Luxo', primaria: '#1E293B', secundaria: '#B4975A', destaque: '#F8FAFC', vibe: 'Alto padrão, discrição e exclusividade.' },
      { id: 'urbana', nome: 'Urbana', primaria: '#475569', secundaria: '#EF4444', destaque: '#FFFFFF', vibe: 'Apartamentos modernos e vida na cidade.' },
      { id: 'litoral', nome: 'Litoral', primaria: '#0EA5E9', secundaria: '#F0F9FF', destaque: '#FDE68A', vibe: 'Veraneio, leveza e clima de férias.' },
    ],
  },
  {
    id: 'academia',
    nome: 'Academia / Personal Trainer',
    estilos: [
      { id: 'performance', nome: 'Performance', primaria: '#000000', secundaria: '#FFFF00', destaque: '#E5E7EB', vibe: 'Resultados extremos e superação.' },
      { id: 'wellness', nome: 'Wellness', primaria: '#10B981', secundaria: '#ECFDF5', destaque: '#374151', vibe: 'Saúde mental, equilíbrio e funcional.' },
      { id: 'forca', nome: 'Força', primaria: '#B91C1C', secundaria: '#111827', destaque: '#D1D5DB', vibe: 'Musculação pesada, tradição e resistência.' },
    ],
  },
  {
    id: 'educacao',
    nome: 'Educação / Cursos Online',
    estilos: [
      { id: 'foco', nome: 'Foco', primaria: '#2563EB', secundaria: '#F8FAFC', destaque: '#F59E0B', vibe: 'Concentração, clareza e aprendizado rápido.' },
      { id: 'criativa', nome: 'Criativa', primaria: '#8B5CF6', secundaria: '#FDF4FF', destaque: '#10B981', vibe: 'Design, artes e pensamento fora da caixa.' },
      { id: 'academica', nome: 'Académica', primaria: '#1E3A8A', secundaria: '#E5E7EB', destaque: '#991B1B', vibe: 'Conhecimento profundo, seriedade e certificação.' },
    ],
  },
  {
    id: 'tecnologia',
    nome: 'Tecnologia / SaaS',
    estilos: [
      { id: 'futurista', nome: 'Futurista', primaria: '#0F172A', secundaria: '#7DD3FC', destaque: '#818CF8', vibe: 'IA, automação e interface de próxima geração.' },
      { id: 'clean-sw', nome: 'Clean SW', primaria: '#FFFFFF', secundaria: '#F1F5F9', destaque: '#2563EB', vibe: 'Usabilidade máxima, clareza e foco no utilizador.' },
      { id: 'dark-dev', nome: 'Dark Dev', primaria: '#000000', secundaria: '#00FF41', destaque: '#333333', vibe: 'Desenvolvedores, código e segurança.' },
    ],
  },
]

export const DEFAULT_CATALOG_KEY = 'tecnologia:clean-sw'

/** Id do estilo personalizado (cores escolhidas pelo cliente). */
export const CUSTOM_STYLE_ID = 'custom'

export function catalogKey(nicheId: string, styleId: string): string {
  return `${nicheId}:${styleId}`
}

export function isCustomCatalogKey(key: string | undefined): boolean {
  return parseCatalogKey(key)?.styleId === CUSTOM_STYLE_ID
}

export function parseCatalogKey(key: string | undefined): { nicheId: string; styleId: string } | null {
  if (!key?.includes(':')) return null
  const [nicheId, styleId] = key.split(':')
  if (!nicheId || !styleId) return null
  return { nicheId, styleId }
}

export function findCatalogStyle(nicheId: string, styleId: string): ThemePaletteStyle | null {
  const niche = WHITE_LABEL_THEME_CATALOG.find((n) => n.id === nicheId)
  return niche?.estilos.find((s) => s.id === styleId) ?? null
}

export function findCatalogStyleByKey(key: string | undefined): {
  niche: ThemePaletteNiche
  style: ThemePaletteStyle
} | null {
  const parsed = parseCatalogKey(key)
  if (!parsed) return null
  const niche = WHITE_LABEL_THEME_CATALOG.find((n) => n.id === parsed.nicheId)
  const style = niche?.estilos.find((s) => s.id === parsed.styleId)
  if (!niche || !style) return null
  return { niche, style }
}

export function matchCatalogKeyFromColors(
  primaria: string,
  secundaria: string,
  destaque: string
): string | null {
  const norm = (c: string) => c.trim().toLowerCase()
  for (const niche of WHITE_LABEL_THEME_CATALOG) {
    for (const style of niche.estilos) {
      if (
        norm(style.primaria) === norm(primaria) &&
        norm(style.secundaria) === norm(secundaria) &&
        norm(style.destaque) === norm(destaque)
      ) {
        return catalogKey(niche.id, style.id)
      }
    }
  }
  return null
}
